module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"catalog":"Catalog","list":"List","table":"Table","chart":"Chart"},"ja":{"catalog":"カタログ","list":"一覧","table":"テーブル","chart":"チャート"}}')
  delete Component.options._Ctor
}
